import { css } from 'aphrodite';
import React, { FC } from 'react';
import { style } from './style';

interface Props {
  forwardedRef: any;
  value: string;
  id: string;
  name: string;
}

export const SurveyRadioButton: FC<Props> = ({ id, name, value, forwardedRef }) => {
  const styles = style();
  return (
    <label htmlFor={id} className={css(styles.container)}>
      <input ref={forwardedRef} className={css(styles.input)} type='radio' id={id} name={name} value={value} />
      <span className={css(styles.checkmark)}></span>
    </label>
  );
};
